import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

const TrapFocus = ({ trapFocus, children, className, testId }) => {
  const [trapped, setTrapped] = useState(trapFocus);
  const containerRef = useRef();

  useEffect(() => {
    if (trapped === trapFocus) return;

    if (trapFocus) {
      document.addEventListener("focusin", onFocus);
    } else {
      document.removeEventListener("focusin", onFocus);
    }
    setTrapped(trapFocus);

    return () => document.removeEventListener("focusin", onFocus);
  }, [trapFocus]);

  const onFocus = event => {
    if (!containerRef.current.contains(event.target)) {
      event.stopPropagation();
      containerRef.current.focus();
    }
  };

  return (
    <div
      className={className}
      data-auto-id={testId}
      tabIndex="-1"
      ref={containerRef}
    >
      {children}
    </div>
  );
};

TrapFocus.defaultProps = {
  className: "",
  testId: ""
};

TrapFocus.propTypes = {
  trapFocus: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string
};

export default TrapFocus;
